import type { Flow } from '@wix/cli-telemetry';
import { reportCommandStartEvent } from '@wix/cli-telemetry';
import type { Command } from '@commander-js/extra-typings';
import { cwd } from 'node:process';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommandTransaction } from '@wix/cli-panorama';
import type { ProjectModel } from '../model.js';
import { loadProjectModel } from '../model.js';

async function initServices({
  model,
  services,
  cliVersion,
  command,
}: {
  model: ProjectModel;
  services: CommandServices;
  cliVersion: string;
  command: Command<unknown[]>;
}) {
  const { metaSiteId } = model;
  const { biLogger, errorReporter, panorama } = services;

  const project = 'Sites' satisfies Flow;

  errorReporter.setTag('project', project);
  errorReporter.setTag('project.site_id', metaSiteId);

  panorama.setDefaultClientData({ cliProject: project, cliSiteId: metaSiteId });

  biLogger.updateDefaults({
    flow: project,
    command: command.name(),
    cliVersion,
    _msid: metaSiteId,
  });
}

export async function runCommand(
  command: Command<unknown[]>,
  services: CommandServices,
  cliVersion: string,
  commandFn: (model: ProjectModel) => Promise<void>
) {
  const model = await loadProjectModel(cwd());

  await initServices({ model, services, command, cliVersion });

  const commandStatus = reportCommandStartEvent({
    msid: model.metaSiteId,
    biLogger: services.biLogger,
    command,
    cliVersion,
    flow: 'Sites',
  });

  const transaction = createCommandTransaction(services.panorama, command);

  try {
    transaction.start();
    await commandFn(model);
    transaction.finish();
    commandStatus.succeed();
  } catch (e) {
    commandStatus.failed(e);
    throw e;
  }
}
